import React, { useEffect, useState } from "react";
import AuthLayout from "../AuthLayout";
import AuthAlerts from "../Signup/AuthAlerts";
import { useNavigate, useSearchParams } from "react-router-dom";
import { verifyUser } from "../../../helpers";
import { Spinner } from "reactstrap";
import styles from "./userverified.module.scss";

const UserVerified = () => {
  const Navigate = useNavigate();
  const [isVerified, setIsVerified] = useState(false);
  const [loading, setLoading] = useState(true);
  const [params] = useSearchParams();
  const accessToken = params?.get("token") || "";

  const checkUserVerified = async () => {
    try {
      await verifyUser(accessToken);

      setIsVerified(true);
      setLoading(false);
    } catch (error) {
      setIsVerified(false);
      setLoading(false);
    }
  };
  useEffect(() => {
    if (accessToken) {
      checkUserVerified();
    } else {
      Navigate("/");
    }
  }, [accessToken]);
  return (
    <AuthLayout hideSignupLabel>
      {loading ? (
        <>
          <div className={styles["spinner"]}>
            <Spinner className={styles["loader"]} />
          </div>
        </>
      ) : isVerified ? (
        <AuthAlerts
          accountVerified
          buttonOnClick={() => {
            Navigate("/");
          }}
        />
      ) : (
        <>
          <div className={styles["error"]}>
            Error verifying your account. Please refresh to try again.
          </div>
        </>
      )}
    </AuthLayout>
  );
};

export default UserVerified;
